import { PayloadTask } from "routes/regime/components/payload-task"
import { ContentOverrideField } from "routes/regime/components/content-override-field"

// Replaces the task content editing area for collaboration clients: the master task body becomes
// directly editable inline (writing to the payload task override) in place of the read-only display.
export function InlineTaskContentOverride() {
    return (
        <PayloadTask>
            <ContentOverrideField field="contentOverride" sourcePath="content" label="Task content" />
        </PayloadTask>
    )
}
